import * as actionTypes from "../actions/actionTypes";

export default function trashedItems(state = {}, action) {
  switch (action.type) {
    case actionTypes.CLEAR_ALL_RECENTLY_DELETED_SUCCESS:
      return {
        ...state,
        [action.uuid]: action.response.result.items,
      };
    case actionTypes.FETCH_KIT_RECENTLY_DELETED_SUCCESS:
      return {
        ...state,
        [action.uuid]: [
          ...((action.page !== 1 && state[action.uuid]) || []),
          ...action.response.result.items,
        ],
      };
    case actionTypes.BATCH_UPDATE_ITEM_STATUS_SUCCESS: {
      const { entities } = action.response;
      if (!entities.items) return state;

      const successfulItems = action.response.result.items.filter(i => i.success).map(i => i.item);
      if (!successfulItems.length) return state;

      const newState = { ...state };
      successfulItems.forEach(id => {
        const fullItem = entities.items[id],
          { kitId, status } = fullItem,
          oldItems = Array.from(newState[kitId] || []);

        if (status !== "trashed") {
          // Remove items
          const newItems = oldItems.filter(i => id !== i);
          if (newItems.length !== oldItems.length) newState[kitId] = newItems;
        } else {
          // Add items
          newState[kitId] = [id, ...oldItems];
        }
      });

      return newState;
    }
    default:
      return state;
  }
}
